import React from "react";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import app from "../firebase-config";
import { useSelector } from "react-redux";
import ApiCall from "../../Api/ApiCall";
import { AuthEndPoints } from "../../Api/Endpoints";

// Initialize messaging
export const messaging = getMessaging(app);

/**
 * Request notification permission and get FCM token
 * @returns {Promise<string|null>} FCM token if permission granted, null otherwise
 */
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BC97i4UgBv5pDFyORGcYFlhvFDLOOWXVmwBvr1wh9790ksmOhBy78J9wFUBFIOk_AlqPakN5TogvHf6ZyIaCWds",
      });
      console.log("FCM Token==>", token);
      return token;
    } else {
      console.error("Notification permission denied");
      return null;
    }
  } catch (err) {
    console.error("Error requesting notification permission:", err);
    return null;
  }
};

/**
 * Subscribe to foreground messages
 * @param {Function} callback - Callback function to handle the message
 * @returns {Function} Unsubscribe function
 */
export const subscribeToForegroundMessages = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log("Received foreground message:", payload);
    callback(payload);
  });
};

/**
 * Update FCM token on the server
 * @param {string} token - FCM token
 * @param {string} userId - User ID
 * @returns {Promise<boolean>} Success status
 */
export const updateFCMToken = async (token, userId) => {
  try {
    const data = {
      userId,
      fcmToken: token,
    };
    const res = await ApiCall("post", AuthEndPoints.addFcmToken, data);

    if (!res.success) {
      throw new Error("Failed to update FCM token");
    }

    return true;
  } catch (error) {
    console.error("Error updating FCM token:", error);
    return false;
  }
};

/**
 * Initialize notification system
 * @param {string} userId - User ID
 * @returns {Promise<boolean>} Success status
 */
// export const initializeNotifications = async (userId) => {
//   try {
//     const token = await requestNotificationPermission();
//     if (token && userId) {
//       const success = await updateFCMToken(token, userId);
//       if (success) {
//         localStorage.setItem('fcmToken', token);
//         return true;
//       }
//     }
//     return false;
//   } catch (error) {
//     console.error('Error initializing notifications:', error);
//     return false;
//   }
// };
